import { render, staticRenderFns } from "./MobileFixedHeader.vue?vue&type=template&id=20942b1c&scoped=true"
import script from "./MobileFixedHeader.vue?vue&type=script&lang=js"
export * from "./MobileFixedHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileFixedHeader.vue?vue&type=style&index=0&id=20942b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20942b1c",
  null
  
)

export default component.exports